import React from "react";
import PropTypes from "prop-types";

//
import { Modal } from "react-bootstrap";

function ImageModal({ show, setShow, image }) {
  return (
    <Modal
      centered
      size="md"
      show={show}
      onHide={() => setShow(false)}

    >
      <Modal.Header closeButton>
        <h5>Image Preview</h5>
      </Modal.Header>

      <Modal.Body>
        <img src={image} alt="image" className="img-fluid"/>
      </Modal.Body>
    </Modal>
  );
}

ImageModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
};

export default ImageModal;
